// global.scss pins every .v-dialog__content to z-index 1111. Vuetify places
// a new dialog's backdrop one above the highest dialog it still sees as
// active, so a dialog opened while another is closing in the same tick gets
// a backdrop at 1112 - above its own content - and cannot be clicked or
// closed. Only one dialog may therefore be open at a time; open the next
// one only once none is active.
export function whenNoDialogIsActive(fn, attempts = 0) {
  const stillActive = document.querySelector('.v-dialog__content--active');
  if (!stillActive || attempts >= 60) {
    fn();
    return;
  }
  requestAnimationFrame(() => whenNoDialogIsActive(fn, attempts + 1));
}
